import { Button, Space, Table, Tag } from "antd";
import { useMemo, useState } from "react";
import { EditOutlined, OrderedListOutlined } from "@ant-design/icons";
import QuestionsListModal from "./QuestionsListModal";

const TopicTable = (props) => {
  const { topics, showModal, loading } = props;

  const [selectedTopic, setSelectedTopic] = useState(null);

  const columns = useMemo(
    () => [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: "10%",
        render: (status) => (
          <Tag color={status === "active" ? "green" : "red"}>
            {status === "active" ? "Active" : "Inactive"}
          </Tag>
        ),
      },
      {
        title: "Branches",
        dataIndex: "branch_ids",
        key: "branch_ids",
        width: "10%",
        render: (branch_ids) => <span>{branch_ids.length}</span>,
      },
      {
        title: "Actions",
        key: "actions",
        width: "5%",
        render: (_, record) => (
          <Space>
            <Button icon={<EditOutlined />} onClick={() => showModal(record)} />
            <Button
              icon={<OrderedListOutlined />}
              onClick={() => setSelectedTopic(record)}
              disabled={!record?.questions?.length}
            />
          </Space>
        ),
      },
    ],
    []
  );

  return (
    <>
      <Table
        columns={columns}
        dataSource={topics}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }}
      />
      {selectedTopic && (
        <QuestionsListModal
          handleCancel={() => setSelectedTopic(null)}
          selectedTopic={selectedTopic}
        />
      )}
    </>
  );
};

export default TopicTable;
